// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.connect-section {
  padding: 4rem 0;
  background: #f8fafc;
}

.connect-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  text-align: center;
}

.connect-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #1e293b;
  margin-bottom: 1.5rem;
  line-height: 1.3;
}

.connect-description {
  font-size: 1.125rem;
  color: #64748b;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.7;
}

@media (max-width: 768px) {
  .connect-section {
    padding: 3rem 0;
  }

  .connect-title {
    font-size: 2rem;
  }

  .connect-description {
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GuestPage/Connect-Section/ConnectSection.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".connect-section {\n  padding: 4rem 0;\n  background: #f8fafc;\n}\n\n.connect-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1rem;\n  text-align: center;\n}\n\n.connect-title {\n  font-size: 2.5rem;\n  font-weight: bold;\n  color: #1e293b;\n  margin-bottom: 1.5rem;\n  line-height: 1.3;\n}\n\n.connect-description {\n  font-size: 1.125rem;\n  color: #64748b;\n  max-width: 800px;\n  margin: 0 auto;\n  line-height: 1.7;\n}\n\n@media (max-width: 768px) {\n  .connect-section {\n    padding: 3rem 0;\n  }\n\n  .connect-title {\n    font-size: 2rem;\n  }\n\n  .connect-description {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
